import { render, staticRenderFns } from "./PlatformSelectStep.vue?vue&type=template&id=022c5436&scoped=true"
import script from "./PlatformSelectStep.vue?vue&type=script&lang=js"
export * from "./PlatformSelectStep.vue?vue&type=script&lang=js"
import style0 from "./PlatformSelectStep.vue?vue&type=style&index=0&id=022c5436&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022c5436",
  null
  
)

export default component.exports